// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content___2oGGn","terms":"terms___3DccV"};